(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-delivery-estimator"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__PDP_DELIVERY_ESTIMATOR__) return;
    window.__PDP_DELIVERY_ESTIMATOR__ = true;
    const DEFAULT_FULFILLMENT_MODE = 'shipping';

    function normalizeFulfillmentMode(mode) {
      return mode === 'pickup' ? 'pickup' : DEFAULT_FULFILLMENT_MODE;
    }

    function getPreferredFulfillmentMode() {
      return normalizeFulfillmentMode(window.__PDP_PREFERRED_FULFILLMENT_MODE__);
    }

    function setPreferredFulfillmentMode(mode) {
      window.__PDP_PREFERRED_FULFILLMENT_MODE__ = normalizeFulfillmentMode(mode);
    }

    function getRoot() {
      return document.querySelector('[data-delivery-estimator]');
    }

    function getEls() {
      const root = getRoot();
      if (!root) return null;

      return {
        root: root,
        zip: root.querySelector('[data-delivery-estimator-zip]'),
        submit: root.querySelector('[data-delivery-estimator-submit]'),
        status: root.querySelector('[data-delivery-estimator-status]'),
        results: root.querySelector('[data-delivery-estimator-results]'),
        standardEstimate: root.querySelector('[data-delivery-standard-estimate]'),
        standardPrice: root.querySelector('[data-delivery-standard-price]'),
        expeditedEstimate: root.querySelector('[data-delivery-expedited-estimate]'),
        expeditedPrice: root.querySelector('[data-delivery-expedited-price]')
      };
    }

    function getFulfillmentRoot() {
      return document.querySelector('[data-product-fulfillment]');
    }

    function getFulfillmentEls() {
      const root = getFulfillmentRoot();
      if (!root) return null;

      return {
        root: root,
        shippingToggle: root.querySelector('[data-fulfillment-toggle="shipping"]'),
        pickupToggle: root.querySelector('[data-fulfillment-toggle="pickup"]'),
        shippingPanel: root.querySelector('[data-fulfillment-panel="shipping"]'),
        pickupPanel: root.querySelector('[data-fulfillment-panel="pickup"]'),
        shippingSummary: root.querySelector('[data-fulfillment-summary="shipping"]'),
        pickupSummary: root.querySelector('[data-fulfillment-summary="pickup"]')
      };
    }

    function getCurrentVariantState() {
      const form = document.querySelector('[data-product-form]');
      if (!form) return null;

      let product = null;
      try {
        product = JSON.parse(form.getAttribute('data-product') || '{}');
      } catch (error) {
        product = null;
      }

      const variants = Array.isArray(product && product.variants) ? product.variants : [];
      const master = form.querySelector('select[name="id"], select[data-variants]');
      if (master && master.disabled) {
        return {
          variantId: '',
          available: false
        };
      }

      let variantId = master && master.value ? String(master.value) : '';
      if (!variantId) {
        try {
          variantId = new URL(window.location.href).searchParams.get('variant') || '';
        } catch (error) {
          variantId = '';
        }
      }

      const variant = variants.find(function(item) {
        return String(item.id) === String(variantId);
      }) || null;

      const fallbackVariant = variant || variants[0] || null;

      return {
        variantId: fallbackVariant && fallbackVariant.id ? String(fallbackVariant.id) : '',
        available: !!(fallbackVariant && fallbackVariant.available)
      };
    }

    function isPurchaseUnavailable() {
      const fulfillment = getFulfillmentRoot();
      const scope = fulfillment && fulfillment.closest('.js-product-section')
        ? fulfillment.closest('.js-product-section')
        : document;
      const purchaseButtons = scope.querySelector('.purchase-details__buttons');
      const addToCart = scope.querySelector('.add_to_cart');
      const addToCartText = addToCart ? String(addToCart.textContent || '').trim().toLowerCase() : '';

      return !!(
        (purchaseButtons && purchaseButtons.classList.contains('product-is-unavailable'))
        || (
          addToCart
          && addToCart.classList.contains('disabled')
          && (
            addToCartText.indexOf('size unavailable') !== -1
            || addToCartText.indexOf('sold out') !== -1
          )
        )
      );
    }

    function getStorageKey() {
      const root = getRoot();
      return root ? root.getAttribute('data-storage-key') || 'pdp_delivery_zip' : 'pdp_delivery_zip';
    }

    function readStoredZip() {
      try {
        return window.localStorage.getItem(getStorageKey()) || '';
      } catch (error) {
        return '';
      }
    }

    function writeStoredZip(value) {
      try {
        if (value) {
          window.localStorage.setItem(getStorageKey(), value);
        } else {
          window.localStorage.removeItem(getStorageKey());
        }
      } catch (error) {}
    }

    function getEstimateCacheStorageKey() {
      return getStorageKey() + '_estimate_cache';
    }

    function readEstimateCache() {
      try {
        return JSON.parse(window.localStorage.getItem(getEstimateCacheStorageKey()) || '{}') || {};
      } catch (error) {
        return {};
      }
    }

    function writeEstimateCache(zipValue, payload) {
      const cacheKey = normalizeZipForRequest(zipValue) || '__NO_ZIP__';
      try {
        const cache = readEstimateCache();
        cache[cacheKey] = payload;
        window.localStorage.setItem(getEstimateCacheStorageKey(), JSON.stringify(cache));
      } catch (error) {}
    }

    function readEstimateCacheForZip(zipValue) {
      const cacheKey = normalizeZipForRequest(zipValue) || '__NO_ZIP__';
      const cache = readEstimateCache();
      return cache[cacheKey] || null;
    }

    function setStatus(message, muted) {
      const els = getEls();
      if (!els || !els.status) return;
      els.status.textContent = message || '';
      els.status.hidden = !message;
      els.status.classList.toggle('is-muted', !!message && !!muted);
    }

    function setResultsVisible(isVisible) {
      const els = getEls();
      if (!els || !els.results) return;
      els.results.hidden = !isVisible;
    }

    function getNoEstimateMessage() {
      const els = getEls();
      if (!els || !els.root) return 'Enter a valid US ZIP code for delivery date estimate';
      return (
        els.root.getAttribute('data-invalid-zip-label')
        || els.root.getAttribute('data-no-zip-label')
        || 'Enter a valid US ZIP code for delivery date estimate'
      );
    }

    function setLoading(isLoading) {
      const els = getEls();
      if (!els || !els.submit) return;
      els.submit.disabled = !!isLoading;
      els.submit.classList.remove('is-success');
      const defaultLabel = els.submit.getAttribute('data-submit-label') || 'Update estimate';
      els.submit.textContent = isLoading
        ? '...'
        : defaultLabel;
    }

    function setSubmitSuccess() {
      const els = getEls();
      if (!els || !els.submit) return;
      els.submit.disabled = false;
      els.submit.classList.add('is-success');
      els.submit.textContent = '✓';

      window.setTimeout(function() {
        const currentEls = getEls();
        if (!currentEls || !currentEls.submit || currentEls.submit.disabled) return;
        currentEls.submit.classList.remove('is-success');
        currentEls.submit.textContent = currentEls.submit.getAttribute('data-submit-label') || 'Update estimate';
      }, 1400);
    }

    function getPreferredZip() {
      const root = getRoot();
      if (!root) return '';
      const storedZip = readStoredZip();
      if (storedZip) return storedZip;
      return root.getAttribute('data-customer-zip') || '';
    }

    function setVisibility() {
      const els = getEls();
      if (!els) return;
      els.root.hidden = false;
    }

    function syncZipInputFromStorage() {
      const els = getEls();
      if (!els || !els.zip) return;

      const preferredZip = normalizeZipForRequest(getPreferredZip());
      els.zip.value = preferredZip;
    }

    function restoreCachedEstimateFromStorage() {
      const els = getEls();
      if (!els || !els.zip) return false;

      const cachedPayload = readEstimateCacheForZip(els.zip.value);
      if (!cachedPayload) return false;

      applyEstimate(cachedPayload);
      return true;
    }

    function updateShippingCardSummary(text) {
      const fulfillment = getFulfillmentEls();
      if (!fulfillment || !fulfillment.shippingSummary) return;
      fulfillment.shippingSummary.textContent = text || 'Estimate by ZIP code';
    }

    function updatePickupCardSummary() {
      const fulfillment = getFulfillmentEls();
      if (!fulfillment || !fulfillment.pickupSummary || !fulfillment.pickupPanel) return;

      const items = fulfillment.pickupPanel.querySelectorAll('[data-surface-pick-up-inline-item]');
      if (!items.length) {
        fulfillment.pickupSummary.textContent = 'Store availability';
        return;
      }

      const availableItems = Array.from(items).filter(function(item) {
        return item.getAttribute('data-location-available') === 'true';
      });
      const firstAvailable = availableItems[0];
      const pickupTime = firstAvailable ? (firstAvailable.getAttribute('data-pickup-time') || '').trim() : '';

      if (pickupTime) {
        fulfillment.pickupSummary.textContent = pickupTime;
      } else if (availableItems.length > 0) {
        fulfillment.pickupSummary.textContent = availableItems.length + ' store pickup option' + (availableItems.length === 1 ? '' : 's');
      } else {
        fulfillment.pickupSummary.textContent = 'Store availability';
      }
    }

    function setActiveFulfillment(mode) {
      const fulfillment = getFulfillmentEls();
      if (!fulfillment) return;

      const normalizedMode = normalizeFulfillmentMode(mode);
      const isShipping = normalizedMode !== 'pickup';
      if (fulfillment.shippingToggle) {
        fulfillment.shippingToggle.classList.toggle('is-active', isShipping);
        fulfillment.shippingToggle.setAttribute('aria-pressed', isShipping ? 'true' : 'false');
      }
      if (fulfillment.pickupToggle) {
        fulfillment.pickupToggle.classList.toggle('is-active', !isShipping);
        fulfillment.pickupToggle.setAttribute('aria-pressed', !isShipping ? 'true' : 'false');
      }
      if (fulfillment.shippingPanel) {
        fulfillment.shippingPanel.hidden = !isShipping;
        fulfillment.shippingPanel.classList.toggle('is-active', isShipping);
      }
      if (fulfillment.pickupPanel) {
        fulfillment.pickupPanel.hidden = isShipping;
        fulfillment.pickupPanel.classList.toggle('is-active', !isShipping);
      }

      setPreferredFulfillmentMode(normalizedMode);
    }

    function syncFulfillmentVisibility() {
      const fulfillment = getFulfillmentEls();
      const estimator = getEls();
      if (!fulfillment) return;

      const shippingVisible = !!(estimator && !estimator.root.hidden && !isPurchaseUnavailable());

      if (fulfillment.root) {
        fulfillment.root.hidden = !shippingVisible;
      }

      if (fulfillment.shippingToggle) {
        fulfillment.shippingToggle.hidden = !shippingVisible;
      }

      if (fulfillment.pickupToggle) {
        fulfillment.pickupToggle.hidden = !shippingVisible;
      }

      const preferredMode = getPreferredFulfillmentMode();

      if (shippingVisible) {
        setActiveFulfillment(preferredMode === 'pickup' ? 'pickup' : 'shipping');
      }
    }

    function deriveShippingSummaryText(estimateText) {
      const rawText = String(estimateText || '').trim();
      if (!rawText) return 'Estimate by ZIP code';
      return rawText.replace(/^Estimated delivery date:\s*/i, 'Arrives ');
    }

    function hasEstimateContent(data) {
      return !!(
        (data && data.standard && (data.standard.estimate_text || data.standard.price_text))
        || (data && data.expedited && (data.expedited.estimate_text || data.expedited.price_text))
      );
    }

    function applyEstimate(data) {
      const els = getEls();
      if (!els || !data) return;

      const hasEstimate = hasEstimateContent(data);

      if (els.standardEstimate) {
        els.standardEstimate.textContent = data.standard && data.standard.estimate_text ? data.standard.estimate_text : '';
      }

      if (els.standardPrice) {
        els.standardPrice.textContent = data.standard && data.standard.price_text ? data.standard.price_text : '';
      }

      if (els.expeditedEstimate) {
        els.expeditedEstimate.textContent = data.expedited && data.expedited.estimate_text ? data.expedited.estimate_text : '';
      }

      if (els.expeditedPrice) {
        els.expeditedPrice.textContent = data.expedited && data.expedited.price_text ? data.expedited.price_text : '';
      }

      setResultsVisible(hasEstimate);
      setStatus(hasEstimate ? '' : getNoEstimateMessage(), false);
      updateShippingCardSummary(deriveShippingSummaryText(data.standard && data.standard.estimate_text));
    }

    function normalizeZipForRequest(value) {
      const rawValue = String(value || '').trim();
      if (!rawValue) return '';
      const digits = rawValue.replace(/\D/g, '');
      if (digits.length >= 5) return digits.slice(0, 5);
      return rawValue;
    }

    async function fetchEstimate(useZip) {
      const els = getEls();
      const state = getCurrentVariantState();
      if (!els || !state || !state.variantId) return false;

      if (!useZip) {
        setResultsVisible(false);
        setStatus(getNoEstimateMessage(), false);
        return false;
      }

      const params = new URLSearchParams();
      params.set('variant_id', state.variantId);

      const zip = normalizeZipForRequest(els.zip && els.zip.value);
      if (useZip && zip) {
        params.set('zip', zip);
      }

      setLoading(true);
      setStatus('', false);

      try {
        const response = await fetch(els.root.getAttribute('data-endpoint') + '?' + params.toString(), {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json'
          }
        });

        let payload = null;
        try {
          payload = await response.json();
        } catch (error) {
          payload = null;
        }

        if (!response.ok || !payload || payload.ok !== true) {
          throw new Error(payload && payload.error ? payload.error : '');
        }

        applyEstimate(payload);
        writeEstimateCache(useZip ? zip : '', payload);
        return true;
      } catch (error) {
        if (useZip && zip) {
          setResultsVisible(false);
          setStatus(getNoEstimateMessage(), false);
        } else {
          setResultsVisible(false);
          setStatus(getNoEstimateMessage(), false);
          updateShippingCardSummary('Estimate by ZIP code');
        }
        return false;
      } finally {
        setLoading(false);
      }
    }

    function refreshFromCurrentState() {
      setVisibility();
      syncFulfillmentVisibility();
      syncZipInputFromStorage();

      const preferredZip = normalizeZipForRequest(getPreferredZip());
      if (!preferredZip) {
        setResultsVisible(false);
        setStatus(getNoEstimateMessage(), false);
        return;
      }

      if (!restoreCachedEstimateFromStorage()) {
        fetchEstimate(true);
      }
    }

    document.addEventListener('DOMContentLoaded', function() {
      const els = getEls();
      const fulfillment = getFulfillmentEls();
      syncZipInputFromStorage();
      setVisibility();
      setPreferredFulfillmentMode(DEFAULT_FULFILLMENT_MODE);
      setActiveFulfillment(getPreferredFulfillmentMode());
      updateShippingCardSummary('Estimate by ZIP code');
      updatePickupCardSummary();
      syncFulfillmentVisibility();
      const initialZip = normalizeZipForRequest(els && els.zip && els.zip.value);
      if (!initialZip) {
        setResultsVisible(false);
        setStatus(getNoEstimateMessage(), false);
      } else if (!restoreCachedEstimateFromStorage()) {
        fetchEstimate(true);
      }

      if (fulfillment && fulfillment.pickupPanel) {
        const observer = new MutationObserver(function() {
          updatePickupCardSummary();
          syncFulfillmentVisibility();
        });
        observer.observe(fulfillment.pickupPanel, { childList: true, subtree: true });
      }
    });

    document.addEventListener('variant:change', refreshFromCurrentState);
    document.addEventListener('product:variant:change', refreshFromCurrentState);
    document.addEventListener('product:color-swap:done', refreshFromCurrentState);
    document.addEventListener('shopify:section:load', refreshFromCurrentState);
    document.addEventListener('theme:section:load', refreshFromCurrentState);

    async function handleEstimateRequest() {
      const els = getEls();
      const zipValue = normalizeZipForRequest(els && els.zip && els.zip.value);
      if (!zipValue) {
        setResultsVisible(false);
        setStatus(getNoEstimateMessage(), false);
        return false;
      }

      return fetchEstimate(true);
    }

    document.addEventListener('click', function(event) {
      const fulfillmentToggle = event.target.closest('[data-fulfillment-toggle]');
      if (fulfillmentToggle) {
        event.preventDefault();
        event.stopPropagation();
        setActiveFulfillment(fulfillmentToggle.getAttribute('data-fulfillment-toggle') || 'shipping');
        return;
      }

      const button = event.target.closest('[data-delivery-estimator-submit]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      const els = getEls();
      const normalizedZip = normalizeZipForRequest(els && els.zip && els.zip.value);
      writeStoredZip(normalizedZip);
      if (els && els.zip) {
        els.zip.value = normalizedZip;
      }
      handleEstimateRequest().then(function(ok) {
        if (ok && normalizedZip) setSubmitSuccess();
      });
    });

    document.addEventListener('keydown', function(event) {
      const input = event.target.closest('[data-delivery-estimator-zip]');
      if (!input || event.key !== 'Enter') return;

      event.preventDefault();
      event.stopPropagation();
      const els = getEls();
      const normalizedZip = normalizeZipForRequest(els && els.zip && els.zip.value);
      writeStoredZip(normalizedZip);
      if (els && els.zip) {
        els.zip.value = normalizedZip;
      }
      handleEstimateRequest().then(function(ok) {
        if (ok && normalizedZip) setSubmitSuccess();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    (function() {
    const namespace = window.DardanosProductGallery || {};
    const DESKTOP_QUERY = '(min-width: 799px)';

    if (namespace._rafInit) {
      window.cancelAnimationFrame(namespace._rafInit);
      namespace._rafInit = null;
    }

    function isDesktop() {
      if (window.PXUTheme && window.PXUTheme.media_queries && window.PXUTheme.media_queries.large) {
        return window.PXUTheme.media_queries.large.matches;
      }

      return window.matchMedia(DESKTOP_QUERY).matches;
    }

    function getGalleryRoot(target) {
      if (!target) return null;
      if (target instanceof HTMLElement) return target;
      if (target.jquery) return target[0];
      return null;
    }

    function getItems(gallery) {
      return Array.from(gallery.querySelectorAll('.product-gallery__media-item'));
    }

    function getVisibleItems(gallery) {
      return getItems(gallery).filter(function(item) {
        return !item.classList.contains('product-gallery__media-item--variant-hidden')
          && !item.classList.contains('product-gallery__media-item--hidden');
      });
    }

    function getAvailableItems(gallery) {
      return getItems(gallery).filter(function(item) {
        return !item.classList.contains('product-gallery__media-item--variant-hidden');
      });
    }

    function getToggle(gallery) {
      return gallery.closest('[data-product-gallery-wrap]')?.querySelector('[data-desktop-gallery-toggle]') || null;
    }

    function getDotsWrap(gallery) {
      return gallery.closest('[data-product-gallery-wrap]')?.querySelector('[data-product-gallery-dots]') || null;
    }

    function getDotButtons(gallery) {
      const wrap = getDotsWrap(gallery);
      return wrap ? Array.from(wrap.querySelectorAll('[data-product-gallery-dot]')) : [];
    }

    function isSingleVariantMediaMode(gallery) {
      return !!gallery
        && gallery.closest('[data-product-gallery-wrap]')?.dataset.variantMediaMode === 'single-variant';
    }

    function getSelectedVariantMediaId(gallery) {
      if (!gallery) return null;
      const wrap = gallery.closest('[data-product-gallery-wrap]');
      const mediaId = wrap ? wrap.dataset.selectedVariantMediaId : '';
      return mediaId ? String(mediaId) : null;
    }

    function setSelectedVariantMediaId(gallery, mediaId) {
      if (!gallery) return;
      const wrap = gallery.closest('[data-product-gallery-wrap]');
      if (!wrap) return;
      wrap.dataset.selectedVariantMediaId = mediaId ? String(mediaId) : '';
    }

    function applyVariantMediaFilter(gallery, mediaId) {
      if (!gallery) return;

      const thumbnails = gallery.closest('[data-product-gallery-wrap]')?.querySelectorAll('.product-gallery__thumbnail') || [];
      const targetMediaId = mediaId ? String(mediaId) : null;

      if (shouldUseDesktopGrid(gallery) || !isSingleVariantMediaMode(gallery) || !targetMediaId) {
        getItems(gallery).forEach(function(item) {
          item.classList.remove('product-gallery__media-item--variant-hidden');
        });
        Array.from(thumbnails).forEach(function(thumb) {
          thumb.classList.remove('product-gallery__thumbnail--variant-hidden');
        });
        return;
      }

      getItems(gallery).forEach(function(item) {
        const isMatch = String(item.dataset.mediaId || '') === targetMediaId;
        item.classList.toggle('product-gallery__media-item--variant-hidden', !isMatch);
        item.classList.toggle('is-selected', isMatch);
        item.setAttribute('aria-hidden', isMatch ? 'false' : 'true');
      });

      Array.from(thumbnails).forEach(function(thumb) {
        const isMatch = String(thumb.dataset.mediaId || '') === targetMediaId;
        thumb.classList.toggle('product-gallery__thumbnail--variant-hidden', !isMatch);
        thumb.classList.toggle('is-nav-selected', isMatch);
      });

      gallery.dataset.activeIndex = '0';
    }

    function getPrevButton(gallery) {
      return gallery.closest('[data-product-gallery-wrap]')?.querySelector('[data-product-gallery-prev]') || null;
    }

    function getNextButton(gallery) {
      return gallery.closest('[data-product-gallery-wrap]')?.querySelector('[data-product-gallery-next]') || null;
    }

    function getWrap(target) {
      if (!target) return null;
      return target.closest('[data-product-gallery-wrap]');
    }

    function destroyLegacyGallery(gallery) {
      if (!gallery) return;

      const thumbnailGallery = gallery.closest('.js-product-section')?.querySelector('.product_gallery_nav');
      const galleryInstance = window.Flickity && window.Flickity.data ? window.Flickity.data(gallery) : undefined;
      const thumbnailGalleryInstance = thumbnailGallery && window.Flickity && window.Flickity.data
        ? window.Flickity.data(thumbnailGallery)
        : undefined;

      if (galleryInstance !== undefined && window.jQuery) {
        try {
          window.jQuery(gallery).flickity('destroy');
        } catch (_) {}
      }

      if (thumbnailGalleryInstance !== undefined && window.jQuery) {
        try {
          window.jQuery(thumbnailGallery).flickity('destroy');
        } catch (_) {}
      }

      gallery
        .querySelectorAll('.flickity-prev-next-button, .flickity-page-dots')
        .forEach(node => node.remove());

      gallery.classList.remove('flickity-enabled');

      if (thumbnailGallery) {
        thumbnailGallery
          .querySelectorAll('.flickity-prev-next-button, .flickity-page-dots')
          .forEach(node => node.remove());
        thumbnailGallery.classList.remove('flickity-enabled');
      }
    }

    function shouldUseDesktopGrid(gallery) {
      if (!gallery) return false;
      return gallery.dataset.desktopGridGallery === 'true' && isDesktop();
    }

    function shouldUseCustomGallery(gallery) {
      return !!gallery && gallery.dataset.desktopGridGallery === 'true';
    }

    function getActiveIndex(gallery) {
      if (!gallery) return 0;

      const visibleItems = getVisibleItems(gallery);
      if (!visibleItems.length) return 0;

      if (shouldUseDesktopGrid(gallery)) {
        const selected = visibleItems.find(function(item) {
          return item.classList.contains('is-selected');
        });
        return selected ? visibleItems.indexOf(selected) : 0;
      }

      const selected = visibleItems.find(function(item) {
        return item.classList.contains('is-selected');
      });
      if (selected) {
        return visibleItems.indexOf(selected);
      }

      const activeIndex = parseInt(gallery.dataset.activeIndex || '0', 10);
      if (Number.isNaN(activeIndex)) return 0;
      return Math.max(0, Math.min(activeIndex, visibleItems.length - 1));
    }

    function setActiveIndex(gallery, index) {
      if (!gallery) return;

      const items = getItems(gallery);
      const visibleItems = getVisibleItems(gallery);
      const safeIndex = Math.max(0, Math.min(index, visibleItems.length - 1));
      const dots = getDotButtons(gallery);
      const useGrid = shouldUseDesktopGrid(gallery);
      const activeItem = visibleItems[safeIndex] || null;
      const activeMediaId = activeItem ? String(activeItem.dataset.mediaId || '') : '';

      items.forEach((item) => {
        const isVisible = visibleItems.indexOf(item) !== -1;
        const isActive = !!activeItem && item === activeItem;
        item.classList.toggle('is-selected', isActive);
        item.setAttribute('aria-hidden', isActive ? 'false' : isVisible ? 'true' : 'true');
      });

      dots.forEach((dot, dotIndex) => {
        const dotMediaId = String(dot.dataset.mediaId || '');
        const matchingVisibleIndex = visibleItems.findIndex(function(item) {
          return String(item.dataset.mediaId || '') === dotMediaId;
        });
        const isVisible = matchingVisibleIndex !== -1;
        const isActive = isVisible && dotMediaId === activeMediaId;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        dot.hidden = !isVisible;
      });

      const prevButton = getPrevButton(gallery);
      const nextButton = getNextButton(gallery);

      if (prevButton) {
        prevButton.disabled = useGrid || visibleItems.length <= 1 || safeIndex <= 0;
      }

      if (nextButton) {
        nextButton.disabled = useGrid || visibleItems.length <= 1 || safeIndex >= visibleItems.length - 1;
      }
    }

    function getClosestMobileIndex(gallery) {
      if (!gallery || shouldUseDesktopGrid(gallery)) return;

      const items = getItems(gallery);
      const visibleItems = getVisibleItems(gallery);
      if (!items.length) return 0;
      if (!visibleItems.length) return 0;

      const scrollLeft = gallery.scrollLeft || 0;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      visibleItems.forEach(function(item, index) {
        const distance = Math.abs(item.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function syncGallery(gallery) {
      if (!gallery) return;

      const items = getItems(gallery);
      applyVariantMediaFilter(gallery, getSelectedVariantMediaId(gallery));
      const availableItems = getAvailableItems(gallery);
      const toggle = getToggle(gallery);
      const dotsWrap = getDotsWrap(gallery);
      const limit = parseInt(gallery.dataset.desktopGridLimit || '4', 10);
      const expanded = gallery.dataset.desktopGridExpanded === 'true';
      const useGrid = shouldUseDesktopGrid(gallery);

      availableItems.forEach((item, index) => {
        const isOverflow = index >= limit;
        item.classList.toggle(
          'product-gallery__media-item--hidden',
          useGrid && isOverflow && !expanded
        );
      });

      items.forEach((item) => {
        if (availableItems.indexOf(item) === -1) {
          item.classList.remove('product-gallery__media-item--hidden');
        }
      });

      const visibleItems = getVisibleItems(gallery);

      if (dotsWrap) {
        dotsWrap.hidden = useGrid || visibleItems.length <= 1;
      }

      if (useGrid) {
        destroyLegacyGallery(gallery);
        setActiveIndex(gallery, getActiveIndex(gallery));
      } else {
        scrollToIndex(gallery, getActiveIndex(gallery), 'auto');
      }

      if (!toggle) return;

      toggle.hidden = !useGrid || availableItems.length <= limit;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded
        ? (toggle.dataset.labelLess || 'Show Less Images')
        : (toggle.dataset.labelMore || 'Show More Images');
    }

    function expandGallery(gallery, options) {
      if (!gallery) return;

      gallery.dataset.desktopGridExpanded = 'true';
      syncGallery(gallery);

      const mediaId = options && options.mediaId ? String(options.mediaId) : null;
      if (!mediaId) return;

      const target = gallery.querySelector(`[data-media-id="${mediaId}"]`);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function collapseGallery(gallery) {
      if (!gallery) return;

      gallery.dataset.desktopGridExpanded = 'false';
      syncGallery(gallery);

      const wrap = gallery.closest('[data-product-gallery-wrap]');
      const scrollTarget = wrap || gallery;

      if (scrollTarget) {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function revealMediaIfNeeded(gallery, mediaId) {
      if (!gallery || !mediaId) return;

      const target = gallery.querySelector(`[data-media-id="${mediaId}"]`);
      if (!target) return;

      const limit = parseInt(gallery.dataset.desktopGridLimit || '4', 10);
      const targetIndex = parseInt(target.dataset.mediaIndex || '-1', 10);
      const expanded = gallery.dataset.desktopGridExpanded === 'true';

      if (!expanded && targetIndex >= limit) {
        syncGallery(gallery);
        return;
      }

      syncGallery(gallery);
    }

    function scrollToIndex(gallery, index, behavior) {
      if (!gallery) return;

      if (shouldUseDesktopGrid(gallery)) {
        setActiveIndex(gallery, index);
        return;
      }

      const items = getVisibleItems(gallery);
      const safeIndex = Math.max(0, Math.min(index, items.length - 1));
      const targetItem = items[safeIndex];
      if (!targetItem) return;

      gallery.dataset.activeIndex = String(safeIndex);
      setActiveIndex(gallery, safeIndex);
      gallery.scrollTo({
        left: targetItem.offsetLeft,
        behavior: behavior || 'smooth'
      });
    }

    function triggerMobileLightbox(control) {
      const wrap = getWrap(control);
      const gallery = wrap ? wrap.querySelector('.product_gallery[data-product-gallery]') : null;
      if (!gallery) return false;

      const activeItem = gallery.querySelector('.product-gallery__media-item.is-selected');
      const activeLightbox = activeItem ? activeItem.querySelector('.lightbox') : null;

      if (activeLightbox) {
        activeLightbox.click();
      }

      return false;
    }

    function inlineStep(control, delta) {
      const wrap = getWrap(control);
      const gallery = wrap ? wrap.querySelector('.product_gallery[data-product-gallery]') : null;
      if (!gallery) return false;

      scrollToIndex(gallery, getActiveIndex(gallery) + delta);
      return false;
    }

    function inlineGoTo(control, index) {
      const wrap = getWrap(control);
      const gallery = wrap ? wrap.querySelector('.product_gallery[data-product-gallery]') : null;
      if (!gallery) return false;

      scrollToIndex(gallery, index);
      return false;
    }

    function bindMobileScroll(gallery) {
      if (!gallery || shouldUseDesktopGrid(gallery)) return;
      if (gallery.dataset.mobileScrollBound === 'true') return;

      let rafId = null;

      function syncFromScroll() {
        rafId = null;
        if (shouldUseDesktopGrid(gallery)) return;
        const activeIndex = getClosestMobileIndex(gallery);
        gallery.dataset.activeIndex = String(activeIndex);
        setActiveIndex(gallery, activeIndex);
      }

      gallery.addEventListener('scroll', function() {
        if (shouldUseDesktopGrid(gallery)) return;
        if (rafId !== null) return;
        rafId = window.requestAnimationFrame(syncFromScroll);
      }, { passive: true });

      gallery.dataset.mobileScrollBound = 'true';
    }

    function focusMedia(mediaId, galleryTarget) {
      if (!mediaId) return;

      const gallery = getGalleryRoot(galleryTarget)
        || document.querySelector('.product_gallery[data-desktop-grid-gallery="true"]');

      if (!shouldUseCustomGallery(gallery)) return;

      const target = gallery.querySelector(`[data-media-id="${mediaId}"]`);
      if (!target) return;

      if (!shouldUseDesktopGrid(gallery)) {
        const visibleItems = getVisibleItems(gallery);
        const targetIndex = Math.max(0, visibleItems.indexOf(target));
        scrollToIndex(gallery, targetIndex);
        return;
      }

      revealMediaIfNeeded(gallery, mediaId);
      const visibleItems = getVisibleItems(gallery);
      setActiveIndex(gallery, Math.max(0, visibleItems.indexOf(target)));
    }

    function bindGallery(gallery) {
      if (!gallery || gallery.dataset.desktopGridBound === 'true') {
        syncGallery(gallery);
        return;
      }

      const toggle = getToggle(gallery);
      if (toggle) {
        toggle.addEventListener('click', function() {
          const expanded = gallery.dataset.desktopGridExpanded === 'true';

          if (expanded) {
            collapseGallery(gallery);
            return;
          }

          expandGallery(gallery);
        });
      }

      const expandButton = gallery.closest('[data-product-gallery-wrap]')?.querySelector('[data-product-gallery-expand]');
      if (expandButton) {
        expandButton.addEventListener('click', function() {
          triggerMobileLightbox(expandButton);
        });
      }

      gallery.dataset.desktopGridBound = 'true';
      syncGallery(gallery);
    }

    function initGallery(gallery) {
      if (!shouldUseCustomGallery(gallery)) return;
      bindGallery(gallery);
      bindMobileScroll(gallery);
      if (shouldUseDesktopGrid(gallery)) {
        destroyLegacyGallery(gallery);
      }
      syncGallery(gallery);
    }

    function syncGalleryForVariant(variant) {
      document
        .querySelectorAll('.product_gallery[data-desktop-grid-gallery="true"]')
        .forEach(function(gallery) {
          if (!isSingleVariantMediaMode(gallery)) {
            return;
          }

          const mediaId = variant && (variant.featured_media?.id || variant.featured_image?.id)
            ? String(variant.featured_media?.id || variant.featured_image?.id)
            : '';

          setSelectedVariantMediaId(gallery, mediaId);
          applyVariantMediaFilter(gallery, mediaId);
          syncGallery(gallery);

          if (mediaId) {
            focusMedia(mediaId, gallery);
          }
        });
    }

    function init() {
      document
        .querySelectorAll('.product_gallery[data-desktop-grid-gallery="true"]')
        .forEach(gallery => {
          initGallery(gallery);
        });
    }

    function scheduleInit() {
      if (namespace._rafInit) return;

      namespace._rafInit = window.requestAnimationFrame(function() {
        namespace._rafInit = null;
        init();
      });
    }

    namespace.initGallery = initGallery;
    namespace.init = init;
    namespace.scheduleInit = scheduleInit;
    namespace.syncGallery = syncGallery;
    namespace.focusMedia = focusMedia;
    namespace.isDesktopGrid = shouldUseDesktopGrid;
    namespace.isCustomGallery = shouldUseCustomGallery;
    namespace.inlineStep = inlineStep;
    namespace.inlineGoTo = inlineGoTo;
    window.DardanosProductGallery = namespace;

    if (!namespace._eventsBound) {
      namespace._onReady = function() {
        scheduleInit();
      };

      namespace._onResize = function() {
        scheduleInit();
      };

      namespace._onSwap = function() {
        scheduleInit();
      };

      namespace._onVariantChange = function(event) {
        syncGalleryForVariant(event && event.detail ? event.detail.variant : null);
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', namespace._onReady, { once: true });
      } else {
        scheduleInit();
      }

      namespace._mediaQuery = window.matchMedia(DESKTOP_QUERY);
      if (namespace._mediaQuery && typeof namespace._mediaQuery.addEventListener === 'function') {
        namespace._mediaQuery.addEventListener('change', namespace._onResize);
      } else {
        window.addEventListener('orientationchange', namespace._onResize, { passive: true });
      }
      document.addEventListener('product:color-swap:done', namespace._onSwap);
      document.addEventListener('variant:change', namespace._onVariantChange);
      document.addEventListener('product:variant:change', namespace._onVariantChange);
      namespace._eventsBound = true;
    } else {
      scheduleInit();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
